import { selectMaindeckCards } from 'redux/deck/selectors'
import { useAppSelector } from 'redux/hooks'

const CanlanderPoints = () => {
  const cards = useAppSelector(selectMaindeckCards)
  const totalPoints = cards.reduce((sum, card) => sum + (card.canlanderPoints || 0), 0)

  return <div>Total pts: {totalPoints}</div>
}

export default CanlanderPoints
